import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkChangeExemption } from '../types';

const onRestoreExemption: IThunkChangeExemption = thunk(async (_, { exemptionId, ...client }) => {
  await api.communityEngagement.recoverExemption(client, exemptionId);
});

export default onRestoreExemption;
